var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Buscador",
    _vm._b(
      {
        staticStyle: { "margin-bottom": "11px", "margin-top": "8px" },
        attrs: { "append-icon": "search" }
      },
      "Buscador",
      Object.assign({}, _vm.$props, _vm.$attrs),
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }